'use client';

import Link from 'next/link'
import { SocialMediaIcon } from '../ui/SocialMediaIcon'
import Image from 'next/image'
import { useParams } from 'next/navigation';
import { Url } from 'url';

import volantBrand from '@/public/images/volant-brand.svg'
import styles from './MainFooter.module.scss'


export const MainFooter = ({ navigation, dictionary }: { navigation: any,dictionary: any }) => {
    const { lang } = useParams<{ lang: string }>();

    return (
        <footer className={styles.footer}>
            <section>
                <nav className={styles.nav}>
                    <ul className={styles.menu}>
                        {navigation?.menu?.map((item: any, index: number) => (
                            <li key={`footerNavigation-${index}`} className={styles.list}>
                                <Link href={`${lang === 'fa' ? '' : `/${lang}`}/${item.link}`} className={styles.link} prefetch={false}>{item.title}</Link>
                            </li>
                        ))}
                    </ul>
                    <ul className={styles.socialIcons}>
                        {navigation?.social && Object?.entries(navigation?.social)?.map(([key, value]: [string, Url | unknown]) => {
                            if (value) {                                
                                return <li key={key}>
                                    <Link href={value as string} target='_blank' prefetch={false}>
                                        <SocialMediaIcon platform={key as 'x' | 'facebook' | 'youtube' | 'instagram' | 'tiktok'} width={24} height={24} />
                                    </Link>
                                </li>
                            }
                        })}
                    </ul>
                </nav>
            </section>
            <section className={styles.copyright}>
                <span className={styles.text}>{dictionary.meta.copyright}</span>
                <div>
                    <Image src={volantBrand} alt='volant media logo' width={105} height={34} />
                </div>
            </section>
        </footer>
    )
}

export default MainFooter